"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackingEventListener = void 0;
const react_1 = require("react");
function useTrackingEventListener(elementsInitialized, iframeRef, onEvent) {
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (elementsInitialized && iframeRef) {
            const listener = (event) => {
                if (onEvent) {
                    onEvent(event.getType(), event);
                }
            };
            const elementsApi = (_b = (_a = iframeRef.contentWindow) === null || _a === void 0 ? void 0 : _a.revjet) === null || _b === void 0 ? void 0 : _b.elements_api;
            (elementsApi === null || elementsApi === void 0 ? void 0 : elementsApi.addTrackingEventListener) && elementsApi.addTrackingEventListener(listener);
            return () => {
                var _a, _b;
                const elementsApi = (_b = (_a = iframeRef.contentWindow) === null || _a === void 0 ? void 0 : _a.revjet) === null || _b === void 0 ? void 0 : _b.elements_api;
                (elementsApi === null || elementsApi === void 0 ? void 0 : elementsApi.removeTrackingEventListener) && elementsApi.removeTrackingEventListener(listener);
            };
        }
        return undefined;
    }, [elementsInitialized, iframeRef, onEvent]);
}
exports.useTrackingEventListener = useTrackingEventListener;
//# sourceMappingURL=use-tracking-event-listener.js.map